import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'app-checkbox-form',
	templateUrl: './checkbox-form.component.html',
	styleUrls: ['./checkbox-form.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CheckboxFormComponent {
	@Input() form: UntypedFormGroup;

	@Input() id: string;

	@Input() label: string;

	@Input() value = null;

	@Input() checked = false;

	@Input() set disabled(condition: boolean) {
		if (condition) {
			this.form.controls[this.id].disable();
		} else {
			this.form.controls[this.id].enable();
		}
	}

	@Input() required = false;

	constructor() { }
}
